import React, { useMemo, useState } from 'react'

import { params } from '../../../../../redux/reducers/reducer'

import PillarLegs from '../../PillarLegs';
import RightPorchLeg from '../../PillarLegs/RightPorchLeg';
import LeftPorchLeg from '../../PillarLegs/LeftPorchLeg';

const Legs = ({ overlapTrussArr, normalMap, envMap, setLeanToTrussPosArr, dragging }) => {

    const [isEqualLeftHeight, setIsEqualLeftHeight] = useState(false);
    const [isEqualRightHeight, setIsEqualRightHeight] = useState(false);
    const [isAction, setIsAction] = useState(false);
    const [leftPorchLength, setLeftPorchLength] = useState(0);
    const [leanToLength, setLeanToLength] = useState(0)
    const [angle, setAngle] = useState(Math.atan(params.b_l_t_r_pB / 12));

    const trimThickness = 0.2;
    // create state on is equal height

    const trimOffsetHeight = (params.p_r_p / 12) * trimThickness;    
    const leanRoofLeftHeight = (params.b_l_t_r_p / 12) * params.lean_p_w;
    const leanRoofRightHeight = (params.b_l_t_r_pR / 12) * params.leanR_p_w;
    const leanRoofBackHeight = (params.b_l_t_r_pB / 12) * params.leanB_p_w;

    const angleOffset = useMemo(() => {
        return Math.atan(params.b_l_t_r_pB / 12) - angle
    }, [params.b_l_t_r_pB, angle])
    
    useMemo(() => {
        if(params.p_h === leanRoofLeftHeight + params.lean_p_h) {
            setIsEqualLeftHeight(true)
        } else {
            setIsEqualLeftHeight(false)
        }
        if(params.p_h === leanRoofRightHeight + params.leanR_p_h) {
            setIsEqualRightHeight(true)
        } else {
            setIsEqualRightHeight(false)
        }
    }, [params.p_h, params.lean_p_h, params.leanR_p_h, params.leanB_p_h, leanRoofLeftHeight, leanRoofRightHeight, leanRoofBackHeight/* params.b_l_t_r_p, params.b_l_t_r_pR, leanRoofBackHeight, params.b_l_t_r_pB */])

    useMemo(() => {
        if ((isEqualLeftHeight && params.add_left_back_lean_porch && isEqualRightHeight && params.add_right_back_lean_porch)){
            setAngle(Math.atan((leanRoofRightHeight - trimOffsetHeight) / (params.leanB_p_w)))
            setIsAction(true)
        } else if ((isEqualLeftHeight && params.add_left_back_lean_porch)) {
            setAngle(Math.atan((leanRoofLeftHeight - trimOffsetHeight) / (params.leanB_p_w)))
            setIsAction(true)
        } else if ((isEqualRightHeight && params.add_right_back_lean_porch)) {
            setAngle(Math.atan((leanRoofRightHeight - trimOffsetHeight) / (params.leanB_p_w)))
            setIsAction(true)
        } else {
            setAngle(Math.atan(params.b_l_t_r_pB / 12))
            setIsAction(false)
        }
    }, [isEqualLeftHeight, isEqualRightHeight, leanRoofLeftHeight, leanRoofRightHeight, trimOffsetHeight, params.add_left_back_lean_porch, params.add_right_back_lean_porch,  params.b_l_t_r_pB, params.leanB_p_w])


    return (    
        <group rotation={[0, Math.PI, 0]}>
            <PillarLegs leanToKey={'back'} angleOffset={angleOffset} setLeanToTrussPosArr={setLeanToTrussPosArr} normalMap={normalMap} envMap={envMap} overlapTrussArr={overlapTrussArr} leftPorchLength={leftPorchLength} setLeanToLength={setLeanToLength} dragging={dragging} />
            {params.add_left_back_lean_porch && <RightPorchLeg leanToKey={'back'} isAction={isAction} angle={angle} angleOffset = {angleOffset} trimOffsetHeight={trimOffsetHeight} overlapTrussArr={overlapTrussArr} setLeanToTrussPosArr={setLeanToTrussPosArr} leanToLength={leanToLength} leftPorchLength={leftPorchLength} normalMap={normalMap} envMap={envMap} />}
            {params.add_right_back_lean_porch && <LeftPorchLeg leanToKey={'back'} isAction={isAction} angle={angle} angleOffset = {angleOffset} trimOffsetHeight={trimOffsetHeight} overlapTrussArr={overlapTrussArr} setLeanToTrussPosArr={setLeanToTrussPosArr} setLeftPorchLength={setLeftPorchLength} leftPorchLength={leftPorchLength} normalMap={normalMap} envMap={envMap} />}
        </group>
    )
}

export default Legs
